var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"collapse",class:{ '-open': _vm.opened },attrs:{"aria-expanded":_vm.opened}},[_c('button',{staticClass:"collapse__heading",attrs:{"aria-label":_vm.heading},on:{"click":function($event){return _vm.toggle()}}},[_vm._v(_vm._s(_vm.heading))]),_c('div',{staticClass:"collapse__content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }